<template>
  <section>
    <b-modal
      :visible="visible"
      hide-footer
      button-size="sm"
      size="lg"
      modal-cancel="false"
      no-close-on-backdrop
      @close="close"
      id="sale-registration-add"
    >
      <template v-slot:modal-title>Modificar Programación</template>
      <section class="container-fluid">
        <section v-if="registration.id !== null">
          <ValidationObserver ref="form" v-slot="{ invalid }">
            <form @submit.prevent="add">
              <section class="row">
                <!-- Estudiante -->
                <div class="col-6">
                  <div class="form-group required">
                    <label class="control-label" for="type">Estudiante</label>
                    <p>
                      {{ registration.student_fullname }}
                    </p>
                  </div>
                </div>
              </section>

              <section class="row">
                <!-- Curso -->
                <div class="col">
                  <div class="form-group">
                    <label class="control-label" for="course_offered"
                      >Curso</label
                    >
                    <p>
                      {{
                        `${registration.course_name} (${registration.courses_offered_parallel})`
                      }}
                    </p>
                  </div>
                </div>
                <!-- Categoria Pensión -->
                <div class="col">
                  <div class="form-group">
                    <label class="control-label" for="syllabus_tuition"
                      >Categoria Pensión</label
                    >
                    <p>
                      {{ registration.syllabus_tuition_name }} - Bs.
                      {{ registration.tuition_price | currency }}
                    </p>
                  </div>
                </div>
              </section>

              <section class="row">
                <template v-if="registration.id !== null">
                  <StudentCourseOffered
                    v-model="registration.course_offered_id"
                    :syllabus_id="registration.syllabus_id"
                    :period="registration.courses_offered_period"
                    :course_id="registration.course_id"
                    :value="registration.course_offered_id"
                    :changeParallel="true"
                    :year="registration.courses_offered_year"
                    :student_id="student_id"
                    @course_offered="setCourseOffered"
                  ></StudentCourseOffered>
                </template>
              </section>

              <section class="row" v-if="registration.sale_id !== 0">
                <!-- Formas de pago -->
                <div class="col">
                  <PaymentMethodRadioInput
                    v-model="registration.payment_method_id"
                    :name="'payment_method_id'"
                    :rules="'required'"
                    :value="registration.payment_method_id"
                    :disabled="registration.payment_method_id == 6"
                  />
                </div>
                <!-- Observación de pago -->
                <div class="col">
                  <div class="form-group">
                    <ValidationProvider
                      name="sale_observation"
                      rules="max:180"
                      v-slot="{ valid, errors }"
                    >
                      <label class="control-label" for="sale_observation"
                        >Observación de pago</label
                      >
                      <input
                        type="text"
                        v-model="registration.sale_observation"
                        class="form-control form-control-sm"
                        id="sale_observation"
                        maxlength="180"
                      />
                      <b-form-invalid-feedback :state="valid">{{
                        errors[0]
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                </div>
              </section>

              <b-button type="button" size="sm" variant="danger" @click="close">
                <CIcon size="sm" name="cil-x-circle" /> Cancelar
              </b-button>

              <button
                type="submit"
                class="btn btn-success btn-sm float-right"
                variant="success"
                :disabled="invalid || addLoader"
              >
                <span v-if="!addLoader">
                  <CIcon size="sm" name="cil-save" /> Guardar
                </span>
                <span v-if="addLoader">
                  Cargando
                  <CSpinner color="success" size="sm" />
                </span>
              </button>
            </form>
          </ValidationObserver>
        </section>
      </section>
    </b-modal>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BModal,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max, max_value } from "vee-validate/dist/rules";
//services
import Registrations from "@/plugins/services/registrations";
import Students from "@/plugins/services/students";
//components
import StudentCourseOffered from "@/entities/students/student-course-offered/StudentCourseOffered";
import PaymentMethodRadioInput from "@/entities/payment-methods/PaymentMethodRadioInput";

export default {
  name: "RegistrationEditModal",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    BModal,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    StudentCourseOffered,
    PaymentMethodRadioInput,
  },
  props: {
    modShowRegistrationEditMod: { type: Boolean, required: true },
    student_id: { type: Number, required: true },
    registration_id: { type: Number, required: true },
  },
  data() {
    return {
      registration: {
        id: null,
        course_offered_id: null,
      },
      student: {},
      mode: { shape: "pill" },
      color: "primary",
      addLoader: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
      loaderPaid: true,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowRegistrationEditMod;
    },
  },
  mounted() {
    this.addLoader = false;
    this.getDataStudent(this.student_id);
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("max_value", {
      ...max_value,
      message: "Por favor, escribe un valor menor o igual a {max}.",
    });
  },
  watch: {},
  methods: {
    add() {
      this.addLoader = true;
      this.registration.created_by = this.userAuth.username;
      this.registration.student_id = this.student_id;
      this.registration.user_id = this.userAuth.id;
      Registrations.edit(this.registration.id, this.registration)
        .then((res) => {
          this.addLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.addLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Item no encontrado.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.closeModal(null, 500);
          }
        });
    },
    getDataRegistration(id) {
      Registrations.getOne(id)
        .then((res) => {
          this.registration = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Programación no encontrada.");
            this.close();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.close();
          }
        });
    },
    getDataStudent(id) {
      Students.getData(id)
        .then((res) => {
          this.student = res.data;
          this.getDataRegistration(this.registration_id);
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.close();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.close();
          }
        });
    },
    closeModal(data = null, status = 200) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("registrationEditModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
    setCourseOffered(response) {
      if (response.data !== null) {
        this.registration.course_offered_id = response.data.id;
        this.registration.course_offered_name = response.data.course_name;
      }
    },
  },
};
</script>
